import {
  HOME_BANNER_UPLOAD_REQUEST,
  HOME_BANNER_UPLOAD_SUCCESS,
  HOME_BANNER_UPLOAD_FAIL,
  HOME_BANNER_FETCH_REQUEST,
  HOME_BANNER_FETCH_SUCCESS,
  HOME_BANNER_FETCH_FAIL,
  HOME_BANNER_DELETE_REQUEST,
  HOME_BANNER_DELETE_SUCCESS,
  HOME_BANNER_DELETE_FAIL,
} from "../../constants/admin/homeBannerConstants";

const initialState = {
  loading: false,
  success: false,
  error: null,
  images: [],
  message: null,
};

// 🔹 Single Reducer for Home Banner Actions
export const homeBannerReducer = (state = initialState, action) => {
  switch (action.type) {
      case HOME_BANNER_UPLOAD_REQUEST:
      case HOME_BANNER_FETCH_REQUEST:
      case HOME_BANNER_DELETE_REQUEST:
          return { ...state, loading: true, success: false, error: null };

      case HOME_BANNER_UPLOAD_SUCCESS:
          return { ...state, loading: false, success: true, images: action.payload.images };

      case HOME_BANNER_FETCH_SUCCESS:
          return { ...state, loading: false, images: action.payload };

      case HOME_BANNER_DELETE_SUCCESS:
          return { ...state, loading: false, success: true, message: action.payload.message };

      case HOME_BANNER_UPLOAD_FAIL:
      case HOME_BANNER_FETCH_FAIL:
      case HOME_BANNER_DELETE_FAIL:
          return { ...state, loading: false, error: action.payload };

      default:
          return state;
  }
};
